var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");
commerce.department = require("./department"); 
commerce.product_name = require("./product_name");
